import { render, staticRenderFns } from "./declaracao-mensal.vue?vue&type=template&id=272366c4&"
import script from "./declaracao-mensal.vue?vue&type=script&lang=js&"
export * from "./declaracao-mensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports